<template>
    <div class="popup popup-priceTips" :class="{ 'modal-in': isShow, 'modal-out': !isShow}" id="tagDetailPopup">
        <div class="shorexDetail-title js-returnDetailBtn">
            <p>优惠信息</p>
            <a class="shorexDetail-returnButton close-popup" @click="goBack()">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
            </a>
        </div>
        <div class="tagDetail">
            <div class="tagDetail-container scroll-container">
                <div class="tagDetail-item" v-for="(tag, i) in tags" :key="'tag_'+i">
                    <p class="tagDetail-item-title">{{tag.name}}</p>
                    <div class="tagDetail-item-txt">{{tag.description}}</div>
                </div>
                <div class="tagDetail-item">
                    <p class="tagDetail-item-title">优惠说明</p>
                    <div class="tagDetail-item-txt">
                        所有既有预订享受的优惠，可以选择转换成当前促销，但之前享受的所有促销优惠必须取消。<br>
                        上述限时闪惠可与游轮公司品牌特惠同享（另有说明的除外），不可与其他限时闪惠、船上消费抵用金、优惠券、升舱及任何其他活动等同享
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    name: "CruiseTagPopup",
    props: {
        onGoBack: {
            type: Function
        },
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        },
        tags: {
            type: Array,
            default () {
                return []
            }
        }
    },
    methods:{
        goBack() {
            this.onGoBack()
        }
    }
}
</script>

<style lang="less" scoped>
#tagDetailPopup.popup {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(100%, 0, 0);
    display: block;
}
#tagDetailPopup.modal-in {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(0, 0, 0);
}
#tagDetailPopup.modal-out {
    transform: translate3d(100%, 0, 0);
}

#tagDetailPopup {
    .shorexDetail-title {
        padding: 15px 20px;
        background-color: #fff;
        overflow: hidden;
        text-align: center;
        margin-bottom: 10px;
        position: fixed;
        width: 100%;
        z-index: 10;
        > p {
            
            font-size: 14px;
            color: #333333;
            letter-spacing: 1px;
            text-align: center;
            margin: 0;
        }
        .shorexDetail-returnButton {
            width: 30px;
            position: absolute;
            top: 15px;
            left: 20px;
            text-align: left;
            > img {
                width: 33%;
            }
        }
    }
    .tagDetail {
        height: 100%;
        padding-bottom: 50px;
        margin-top: 50px;
        overflow-y: auto;
        .tagDetail-container {
            padding: 15px 20px 0 20px;
            background-color: #fff;
            border-top: 10px solid #F6F7F8;
            .tagDetail-item {
                margin-bottom: 13.5px;
                .tagDetail-item-title {
                    
                    font-size: 12px;
                    color: #4A90E2;
                    letter-spacing: 1px;
                    padding-left: 5px;
                    border-left: 3px solid #4A90E2;
                    margin: 0;
                    line-height: 12px;
                }
                .tagDetail-item-txt {
                    margin-top: 10px;
                    
                    font-size: 12px;
                    color: #666666;
                    letter-spacing: 0;
                    line-height: 20px;
                }
            }
        }
    }
}


</style>

